// React and hooks
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from 'PropTypes';

// Bootstrap components
import { Card, Table, Col, Row, Badge } from 'react-bootstrap';

// Custom components and constants
import StatusStaffTabsRow from 'Components/StatusStaffTabsRow';
import { DATETIME_FORMAT_WEB } from 'Constants/DateFormatConstants';
import { DateTimeFormater } from 'Helpers/DateTimeHelper';
import { setStatusColor } from 'Helpers/UiHelper';

const HistoryTab = (props) => {
  const { flyToWorkTicketInfo, refreshComponent } = props;
  const [flightTicketAudit, setFlightTicketAudit] = useState([]);

  useEffect(() => {
    if (!flyToWorkTicketInfo.audit || flyToWorkTicketInfo.audit.length === 0) return;

    if (!Array.isArray(flyToWorkTicketInfo.audit)) flyToWorkTicketInfo.audit = [flyToWorkTicketInfo.audit];

    setFlightTicketAudit(flyToWorkTicketInfo.audit);
  }, [flyToWorkTicketInfo, refreshComponent]);

  const getGreenlightBadge = (value) => {
    if (value === null || value === undefined || value === '') return <span className="text-muted">-</span>;
    const isTrue = value === true || value === 'true' || value === 'Yes';
    return <Badge bg={isTrue ? 'success' : 'secondary'}>{isTrue ? 'Yes' : 'No'}</Badge>;
  };

  return (
    <React.Fragment>
      <StatusStaffTabsRow flyToWorkTicketInfo={flyToWorkTicketInfo} />
      <hr className="mt-0" />
      <Row>
        <Col lg={12}>
          <Card className="staff-profile-card">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
                <i className="fa fa-history me-2"></i>
                History Audit
                {flightTicketAudit.length > 0 && (
                  <Badge bg="primary" className="ms-2">
                    {flightTicketAudit.length}
                  </Badge>
                )}
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              {!flightTicketAudit || flightTicketAudit.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fa fa-history fa-3x text-muted mb-3"></i>
                  <p className="text-muted mb-0">No history records found</p>
                  <p className="text-muted small">Changes will appear here</p>
                </div>
              ) : (
                <Table striped hover responsive className="mb-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Updated By</th>
                      <th>Group</th>
                      <th>Status Change</th>
                      <th>Greenlight Change</th>
                    </tr>
                  </thead>
                  <tbody>
                    {flightTicketAudit.map((audit) => (
                      <tr key={`${audit.date}-${audit.updatedBy}-${audit.statusTo || ''}`}>
                        <td>
                          <i className="fa fa-clock-o me-2 text-muted"></i>
                          {DateTimeFormater(audit.date, null, DATETIME_FORMAT_WEB)}
                        </td>
                        <td>
                          <i className="fa fa-user me-2 text-muted"></i>
                          {audit.updatedBy || '-'}
                        </td>
                        <td>
                          <Badge bg="info">{audit.group || '-'}</Badge>
                        </td>
                        <td>
                          {audit.statusFrom || audit.statusTo ? (
                            <div className="d-flex align-items-center gap-2">
                              {audit.statusFrom && (
                                <Badge bg={setStatusColor(audit.statusFrom)}>{audit.statusFrom}</Badge>
                              )}
                              {audit.statusFrom && audit.statusTo && <i className="fa fa-arrow-right text-muted"></i>}
                              {audit.statusTo && <Badge bg={setStatusColor(audit.statusTo)}>{audit.statusTo}</Badge>}
                            </div>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          {audit.greenLightFrom !== null || audit.greenLightTo !== null ? (
                            <div className="d-flex align-items-center gap-2">
                              {getGreenlightBadge(audit.greenLightFrom)}
                              {audit.greenLightFrom !== null && audit.greenLightTo !== null && (
                                <i className="fa fa-arrow-right text-muted"></i>
                              )}
                              {getGreenlightBadge(audit.greenLightTo)}
                            </div>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

HistoryTab.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  setRefreshComponent: PropTypes.func,
  refreshComponent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default HistoryTab;
